import React from 'react';
import { AdacText, AdacLink } from '@adac-de/component-library';
import { useFormContext } from 'react-hook-form';
import { FormButtonWrapper } from '../inputs/form-button-wrapper';
import styles from './submit-section.module.scss';
import { SUBMIT_ERROR } from './form-variables';
import { Icon } from '@components/icons/icons';
import { Button } from '@components/button/button';
import { trackProductOrder } from '@utils/tracking/tracking';
import { ErrorText } from '@components/error/error-text';

const label = 'Absenden';
const element = 'Angebot anfordern';

export const dataprotectionText = {
  startOfText:
    'Mit Angebotsanforderung, übermitteln wir Ihre personenbezogenen Daten, die Sie in der Eingabemaske angegeben haben, zur Anbahnung des Vertrages an die ausgewählten Partner. Details dazu entnehmen Sie bitte unserer ',
  linkText: 'Datenschutzinformation',
  endOfText: '.'
};

export type DataProtectionFormFields = {
  dataProtection: string;
};

export const SubmitSection: React.FC<{ selectedPartnerNames: string }> = ({
  selectedPartnerNames
}) => {
  const {
    formState: { errors, isValid }
  } = useFormContext();

  return (
    <>
      <FormButtonWrapper>
        <div>
          {Object.keys(errors).length > 0 && (
            <ErrorText className={styles.error} text={SUBMIT_ERROR} />
          )}
          <Button
            type="submit"
            variant="primary"
            tracking={{
              click: {
                ...(isValid
                  ? {
                      label,
                      element,
                      funnelStep: 15,
                      productVariant: selectedPartnerNames
                    }
                  : {
                      label: 'Felder nicht korrekt ausgefüllt',
                      element: element,
                      interaction: 'funnel_fehler',
                      funnelStep: 15
                    })
              }
            }}
            onClick={() => {
              if (isValid) {
                trackProductOrder({
                  label,
                  element,
                  productVariant: selectedPartnerNames
                });
              }
            }}
          >
            {label}
          </Button>
        </div>
        <div className={styles.verifiedSection}>
          <Icon.Verify width={24} height={24} fill="black60" />
          <AdacText type="medium">Ihre persönlichen Daten sind bei uns sicher.</AdacText>
        </div>
      </FormButtonWrapper>
      <AdacText type="medium" className="margin-top--xxl margin-bottom--l">
        {dataprotectionText.startOfText}
        <AdacLink href="https://www.adac.de/datenschutz/online/" target="_blank">
          {dataprotectionText.linkText}
        </AdacLink>
        {dataprotectionText.endOfText}
      </AdacText>
    </>
  );
};
